import { Form, InputGroup } from "react-bootstrap";

export const Input = ({
  label,
  field,
  type = "text",
  register,
  error,
  withUnit = false,
  unit = "€",
  color,
}) => {
  return (
    <Form.Group className="mb-3">
      <Form.Label style={{ color }}>{label}</Form.Label>
      {withUnit ? (
        <InputGroup>
          <Form.Control
            step=".01"
            type={type}
            inputMode={type === "number" ? "decimal" : undefined}
            pattern={type === "number" ? "[0-9]*[.,]?[0-9]*" : undefined}
            {...register(field, {
              valueAsNumber: type === "number", // Ensures correct number handling
            })}
            isInvalid={error}
          />
          <InputGroup.Text>{unit}</InputGroup.Text>
        </InputGroup>
      ) : (
        <Form.Control
          step=".01"
          type={type}
          inputMode={type === "number" ? "decimal" : undefined}
          pattern={type === "number" ? "[0-9]*[.,]?[0-9]*" : undefined}
          {...register(field, {
            valueAsNumber: type === "number",
          })}
          isInvalid={error}
        />
      )}
      <Form.Control.Feedback type="invalid">
        {error?.message}
      </Form.Control.Feedback>
    </Form.Group>
  );
};
